"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMIT_BACK_TYPE = exports.PERMIT_FRONT_TYPE = void 0;
exports.permitImageOfType = permitImageOfType;
exports.hasBothPermitImages = hasBothPermitImages;
exports.permitImagesRequired = permitImagesRequired;
/**
 * Permit scans are stored as two distinct file types so a school bound by a state
 * rule can tell which side a student still owes. Files uploaded before the sides
 * were distinguished carry the plain "permit" type and satisfy neither.
 */
exports.PERMIT_FRONT_TYPE = "permit_front";
exports.PERMIT_BACK_TYPE = "permit_back";
function permitImageOfType(files, type) {
    return (files || []).find(function (file) { return file.type === type; });
}
function hasBothPermitImages(files) {
    return (permitImageOfType(files, exports.PERMIT_FRONT_TYPE) !== undefined &&
        permitImageOfType(files, exports.PERMIT_BACK_TYPE) !== undefined);
}
function permitImagesRequired(policiesStoreService) {
    var policy = policiesStoreService.getPolicy("drives");
    return !!policy && policy.policymeta.require_permit_images === "Y";
}
